export type Ratings = {
  materialRate: number,
  materialClarity: number,
  materialInterest: number,
  materialRelevance: number,
  materialComment?: string,
};

export enum RatingStep {
  Rate = "Rate",
  AddComment = "addComment",
  End = "end",
}

export const MATERIAL_QUESTIONS: Record<string, string> = {
  materialRate: "Оцените пройденный материал",
  materialClarity: "Оцените насколько был понятен материал",
  materialInterest: "Насколько вам было интересно изучать материал?",
  materialRelevance: "Насколько материал оказался актуальным для вас?",
};

export const UNIT_QUESTIONS: Record<string, string> = {
  courseRate: "Оцените пройденный курс",
};

export const RATING_MAX = 5;
